<template>
  <div class='BairroItem'>
    <div class="bairro">
      <div class="label">Bairro</div>
      <div class="desc">{{ data.bairro }}</div>
    </div>
    <div class="valor">
      <div class="label">Valor</div>
      <div class="valor">{{ data.valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="valor">
      <div class="label">Valor mínimo</div>
      <div class="valor">{{ data.valormin.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="gratis">
      <div class="label">Grátis a partir</div>
      <div class="valor">{{ data.gratisapartir.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) }}</div>
    </div>
    <div class="close" @click="_DeleteFreteBairro(data)">X</div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'BairroItem',
  props: ['data'],
  methods: {
    ...mapActions(['_DeleteFreteBairro'])
  }
}
</script>

<style scoped>
.BairroItem {
  width: 100%;
  display: flex;
  margin: 0.6%;
  background-color: #EEEEEE;
}

.bairro {
  width: 70%;
  padding: 1%;
}

.desc {
  width: 100%;
  text-align: left;
}

.valor {
  width: 10%;
  padding: 1%;
}

.gratis {
  width: 10%;
  padding: 1%;
}

.label {
  text-align: left;
  font-size: 10px;
  color: #333333;
}

.close {
  width: 2%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 12px;
  padding: 2%;
  cursor: pointer;
}

.close:hover {
  color: red
}
</style>
